// extracted by mini-css-extract-plugin
module.exports = {"root":"StreamSummaryPanel_root__9FL3S","rows":"StreamSummaryPanel_rows__3wm1B","row":"StreamSummaryPanel_row__JLjRk","value":"StreamSummaryPanel_value__nsvdJ"};